import { useRef } from "react";
import { useSelector } from "react-redux";
import { Auth } from "../Auth";
import LocalStorageService from "../LocalStorageService";
import RolesHelper from "./RolesHelper";
import { Navigate, useLocation } from "react-router-dom";
import Forbidden from "../../../components/Forbidden";

// [CANA-589] `a` may be a list: holding the right on any one of them is enough.
const hasPermission = (I, a) => {
    const storedData = LocalStorageService.get('authorizationData') || {};
    const { group_permissions = [] } = storedData;
    const subjects = Array.isArray(a) ? a : [a];
    return Boolean(subjects.some((subject) => group_permissions.includes(I + '_' + subject)) || storedData.is_superuser);
};

// [CANA-654] A route denied when its URL is entered redirects (direct URL,
// stale link). One that was allowed and lost the right while open — stored
// permissions resynced after a 403 — shows the Access denied page instead, so
// the user learns why the page went away. Keyed on the pathname because React
// Router reuses this instance across sibling routes. "Allowed" only counts
// once /me/ has answered since the page load: before that the stored
// permissions may be stale, and a reload on a page whose right was removed
// meanwhile must redirect like any other denied URL. Re-reads the stored
// permissions itself so the sync flag flipping is enough to re-evaluate.
const RouteGuard = ({ I, a, children }) => {
    const { pathname } = useLocation();
    const synced = useSelector((state) => Boolean(state?.me?.synced));
    const allowedPathname = useRef(null);
    if (hasPermission(I, a)) {
        if (synced) {
            allowedPathname.current = pathname;
        }
        return children;
    }
    return allowedPathname.current === pathname
        ? <Forbidden />
        : <Navigate to={RolesHelper.getRedirectPage()} />;
};

// [CANA-829] The dev-only METRC pages have no grantable codename: they open for
// superusers only, and any other user entering their URL is redirected.
export const SuperuserOnly = ({ children }) => {
    const storedData = LocalStorageService.get('authorizationData') || {};
    return storedData.is_superuser ? children : <Navigate to={RolesHelper.getRedirectPage()} />;
};

const Can = (props) => {
    const { I, children, fallback, a, withRedirect, login } = props;
    let returnCondition = hasPermission(I, a);
    // if (superAdmin) {
        // return children;
        // }

    // Auth check if user can see a page
    const isPageCheck = I + '_' + a === 'view_page';
    if (isPageCheck) {
        returnCondition = Auth.isAuthenticated() === login;
    }
    if (withRedirect && !isPageCheck) {
        return <RouteGuard I={I} a={a}>{children}</RouteGuard>;
    }
    const fb = withRedirect ? <Navigate to={RolesHelper.getRedirectPage()} /> : fallback;
    return returnCondition ? children : typeof fb !== 'undefined' ? fb : <></>;
}
export default Can;
